module.exports = __webpack_public_path__ + "img/block-375.609f34d1.jpg";